<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>
<div class="header-container">
	<span>
		<p><span class="previous-page">Home / </span> <span class="current-page"> Lead Bulk Upload</span></p>
	</span>
	<div class="button-container">
		<button mat-raised-button routerLink="/suzuki/create-lead">
			< Back</button>
	</div>
</div>
<div class="container-fluid pl-0">
	<div class="container-upload">
		<div class="title">
			<p class="text-left head-text">Lead Bulk Upload</p>
			<p class="text-left sub-head">Upload .csv, xlsx, xls file for bulk upload</p>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-6 col-sm-8 upload-container">
				<div class="mb-3 d-flex justify-content-between align-items-center">
					<label class="form-label mb-0 upload-label">Upload</label>
					<!-- <div class="d-flex align-items-center col-5" style="margin-right: -15px;">
						<label for="stageSelect" class="form-label mb-0 stage-label">Stage</label>
						<select class="form-select ml-2" id="stageSelect" [(ngModel)]="selectedStage">
							<option selected value="">Select stage</option>
							<option *ngFor="let stage of stages" [value]="stage.id">{{ stage.lead_stage }}</option>
						</select>
					</div> -->
				</div>

				<!-- Show upload box if no file is selected -->
				<div *ngIf="!uploadedFile" id="uploadBox" class="upload-box" (drop)="onFileDrop($event)"
					(dragover)="onDragOver($event)">
					<img src="/assets/images/backup.png" alt="">
					<p class="mt-2">Drag your file(s) or <span class="text-primary"
							(click)="fileInput.click()">browse</span></p>
					<p class="text-muted">Max 10 MB files are allowed</p>
					<input type="file" #fileInput accept=".xls,.xlsx,.csv" (change)="onFileSelect($event)" hidden>
				</div>

				<!-- Show file details if a file is selected -->
				<div *ngIf="uploadedFile" class="file-details mt-4 mb-4">
					<div class="d-flex justify-content-between align-items-center">
						<span style="color:rgb(11, 93, 187);font-weight: 500;">{{ uploadedFile.name }}</span>
						<div class="d-flex">
							<button class="btn btn-danger btn-sm" (click)="deleteFile()">Delete</button>
							<button class="btn btn-primary btn-sm ml-2" (click)="openMapFieldsDialog()">Upload</button>
						</div>
					</div>
					<!-- <div *ngIf="uploadProgress >= 0" class="progress mt-2">
				<div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress" [attr.aria-valuenow]="uploadProgress" aria-valuemin="0" aria-valuemax="100"></div>
			  </div> -->
				</div>

				<p class="text-muted mt-3">Only Support .csv, xlsx, xls</p>
				<hr class="mt-2">
				<p class="download-file"> Download Sample File</p>
				<div class="d-flex justify-content-between align-items-center sample-file mt-2">
					<span>Sample.xlsx</span>
					<button class="btn preview" (click)="openFile()">Preview</button>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #fileSample>
	<h1 mat-dialog-title>
		Sample Data
		<img class="close-button" (click)="onClose()" src="/assets/images/close.png" alt="">
	</h1>
	<div mat-dialog-content>
		<div class="table-container">
			<table>
				<tr>
					<th class="field-head">Field</th>
					<th class="field-value">Value</th>
				</tr>
				<tr>
					<td class="field-head">Stage</td>
					<td class="field-value"> {{leadStage}}</td>
				</tr>
				<tr>
					<td class="field-head">Base Lead Source</td>
					<td class="field-value"> {{baseLeadSource}}</td>
				</tr>
				<tr>
					<td class="field-head">Lead Source </td>
					<td class="field-value">
						<ng-container *ngFor="let data of baseLeadAll">
				<tr *ngIf="data.lead_sources.length > 0">
					{{data.base_lead_source}} : <span *ngFor="let element of data.lead_sources; let i =index;">
						{{element.lead_source}}<span *ngIf="data.lead_sources.length != i+ 1">, </span> </span>
				</tr>
				</ng-container>
				</td>
				</tr>
				<tr>
					<td class="field-head">Sub Source </td>
					<td class="field-value">
						<ng-container *ngFor="let data of leadSourceAll">
				<tr *ngIf="data.lead_sub_sources.length > 0">
					{{data.lead_source}} : <span *ngFor="let element of data.lead_sub_sources; let i =index;">
						{{element.lead_sub_source}}<span *ngIf="data.lead_sub_sources.length != i+ 1">, </span> </span>
				</tr>
				</ng-container>
				</td>
				</tr>
				<!-- <tr>
					<td class="field-head">Lead Source</td>
					<td class="field-value"> {{leadSources}}</td>
				</tr>
				<tr>
					<td class="field-head">Sub Source</td>
					<td class="field-value"> {{leadSubSources}}</td>
				</tr> -->
				<tr>
					<td class="field-head">Category / Model </td>
					<td class="field-value">
						<ng-container *ngFor="let data of productCategory">
				<tr *ngIf="data.productModels.length > 0">
					{{data.product_category}} : <span *ngFor="let element of data.productModels; let i =index;">
						{{element.model}}<span *ngIf="data.productModels.length != i+ 1">, </span> </span>
				</tr>
				</ng-container>
				</td>
				</tr>
				<tr>
					<td class="field-head">Model / Variant </td>
					<td class="field-value">
						<ng-container *ngFor="let data of productModels">
				<tr *ngIf="data.product_variants.length > 0">
					{{data.model}} : <span *ngFor="let element of data.product_variants; let i =index;">
						{{element.variant}}<span *ngIf="data.product_variants.length != i+ 1">, </span> </span>
				</tr>
				</ng-container>
				</td>
				</tr>
				<tr>
					<td class="field-head">Variant / Color </td>
					<td class="field-value">
						<ng-container *ngFor="let data of productColors">
				<tr *ngIf="data.product_colors.length > 0">
					{{data.variant}} : <span *ngFor="let element of data.product_colors; let i =index;">
						{{element}}<span *ngIf="data.product_colors.length != i+ 1">, </span> </span>
				</tr>
				</ng-container>
				</td>
				</tr>
				<tr>
					<td class="field-head">DSE</td>
					<td class="field-value">{{salesUsers}}</td>
				</tr>
				<tr>
					<td class="field-head">Customer Interest</td>
					<td class="field-value">{{customerInterest}}</td>
				</tr>
				<tr>
					<td class="field-head">Finance Source</td>
					<td class="field-value">{{finance}}</td>
				</tr>
			</table>
		</div>
	</div>
	<div mat-dialog-actions class="d-flex justify-content-end">
		<button class="btn white-btn mr-2" (click)="onClose()">Cancel</button>
		<!-- <button class="btn blue-btn mr-2" (click)="downloadFile()">
			<img src="/assets/images/download.png" alt=""> Download File
		</button> -->
		<a class="btn blue-btn mr-2" href="{{fileLink}}" download>
			<img src="/assets/images/download.png" alt=""> Download File
		</a>
	</div>
</ng-template>


<ng-template #mapFields>
	<h1 mat-dialog-title>Map Your Fields
		<img class="close-button" (click)="onMapFieldsClose()" src="/assets/images/close.png" alt="">
	</h1>
	<div mat-dialog-content>
		<form>
			<div class="row">
				<div class="col">
					<h3 class="subheading">Predefined</h3>
				</div>
				<div class="col">
					<h3 class="subheading">Your Fields</h3>
				</div>
			</div>
			<div class="form-group" *ngFor="let field of fields">
				<div class="row align-items-center mt-2">
					<label class="col map-label">{{ field.label }}</label>
					<div class="col">
						<select class="form-select" [(ngModel)]="mappedFields[field.key]"
							[ngModelOptions]="{standalone: true}">
							<option value="">Select field</option>
							<option *ngFor="let header of headers" [value]="header.field">{{ header.field }}</option>
						</select>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div mat-dialog-actions class="d-flex justify-content-end">
		<button class="btn white-btn mr-2" (click)="onMapFieldsClose()">Cancel</button>
		<button class="btn blue-btn mr-2" (click)="uploadFile()">Submit</button>
	</div>
</ng-template>


<ng-template #validationError>
	<h1 mat-dialog-title style="color: #e74f4f;">
		<img src="/assets/images/history-alert.png" alt="" style="margin-right: 3px;margin-bottom: 4px;"> Validation
		Error!
		<img class="close-button" (click)="onClose()" src="/assets/images/close.png" alt="">
	</h1>
	<div mat-dialog-content>
		<div class="table-container">
			<ul>
				<li class="validation-list" *ngFor="let data of validationData">
					{{data}}
				</li>
			</ul>
		</div>
	</div>
	<div mat-dialog-actions class="d-flex justify-content-end">
		<button class="btn white-btn mr-2" (click)="onClose()">Cancel</button>
	</div>
</ng-template>